import { ContractIAImportState } from '../../states/Contract.IAImport.States';
import ContractIAImportCreateReducer from './ContractIAImport.Create.Reducer';
import ContractIAImportGetLastReducer from './ContractIAImport.GetLast.Reducer';
import ContractIAImportGetHistoryReducer from './ContractIAImport.GetHistory.Reducer';
import ContractIAImportRateReducer from './ContractIAImport.Rate.Reducer';
import * as CommonFunctions from '../Common/Functions';

export const CombinedContractIAImportReducer = CommonFunctions.reduceReducers<ContractIAImportState>(
  ContractIAImportGetLastReducer,
  ContractIAImportGetHistoryReducer,
  ContractIAImportCreateReducer,
  ContractIAImportRateReducer,
);
